import { trpc } from '@/lib/trpc';
import { User } from '../User';

const useGoogleAuth = () => {
	const utils = trpc.useUtils();

	const { mutate, isPending, error } = trpc.user.googleAuth.useMutation({
		onSuccess: (response) => {
			if (!response.user) return;
			utils.user.get.setData(undefined, () => {
				return {
					status: 200,
					user: {
						...(response.user as User),
					},
				};
			});
			utils.user.get.invalidate();
		},
	});

	return {
		googleAuth: mutate,
		googleAuthLoading: isPending,
		googleAuthError: error,
	};
};

export default useGoogleAuth;
